export interface PolicyInterface {
  minimum_length: number;
  maximum_length: number;
  upper_case_needed: boolean;
  lower_case_needed: boolean;
  numeric_needed: boolean;
  non_alphanumeric_needed: boolean;
  no_confusing_letters?: boolean;
  no_white_spaces?: boolean;
}

export interface RulesInterface {
  [key: string]: {
    text?: string;
    isChecked?: boolean;
  };
}

export const getCheckedPoliciesLength = (rules: RulesInterface): number => {
  return Object.keys(rules).filter((ruleKey) => {
    return !rules[ruleKey]?.isChecked;
  }).length;
};

export const getPercentValue = (amountOfPolicies: number, checkedPoliciesLength: number): number => {
  if (!amountOfPolicies || !checkedPoliciesLength) {
    return 0;
  }

  return (checkedPoliciesLength * 100) / amountOfPolicies;
};
